import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Centralized axios client.
 *
 * Authentication uses httpOnly Secure cookies set by the backend
 * (`auth_token` for JWT, `session_token` for Google OAuth).
 * `withCredentials: true` ensures these cookies are sent on every request.
 *
 * Legacy fallback : if an older client still has a token in localStorage
 * (pre-migration), we attach it as Authorization Bearer so the user is not
 * logged out abruptly. After 90 days this fallback can be removed.
 */
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const legacyToken = localStorage.getItem("auth_token");
  if (legacyToken && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${legacyToken}`;
  }
  return config;
});

export default api;
